// Environment Configuration
const ENV_CONFIG = {
  // Development API URL
  DEV_API_URL: 'http://localhost:8000',
  
  // Production API URL  
  PROD_API_URL: 'https://api.eighteenflow.in',
  
  // Get current environment
  isDevelopment: () => {
    // Check multiple indicators for development environment
    return (
      process.env.NODE_ENV === 'development' ||
      window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1' ||
      window.location.port === '3000'
    );
  },
  
  // Get the appropriate API base URL
  getApiBaseUrl: () => {
    return ENV_CONFIG.isDevelopment() 
      ? ENV_CONFIG.DEV_API_URL 
      : ENV_CONFIG.PROD_API_URL;
  },
  
  // Get API URL with /api suffix
  getApiUrl: () => {
    return `${ENV_CONFIG.getApiBaseUrl()}/api`;
  },
  
  // Get base URL without /api suffix (for file uploads, etc.)
  getBaseUrl: () => {
    return ENV_CONFIG.getApiBaseUrl();
  }
};

export default ENV_CONFIG; 